var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYaraSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 147.39999 147.60001",
    height: 147.60001,
    width: 147.39999,
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs161"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style102",
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#00205B;}\n")), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    id: "path104",
    d: "M 137.4,0 H 10 C 4.5,0 0,4.5 0,10 v 127.6 c 0,5.5 4.5,10 10,10 h 127.4 c 5.5,0 10,-4.5 10,-10 V 10 c 0,-5.5 -4.5,-10 -10,-10 z m 6.7,137.6 c 0,3.6 -3,6.5 -6.5,6.5 H 10.1 c -3.6,0 -6.5,-3 -6.5,-6.5 V 10 c 0,-3.6 3,-6.5 6.5,-6.5 h 127.4 c 3.6,0 6.5,3 6.5,6.5 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    id: "path106",
    d: "m 144.1,137.6 c 0,3.6 -3,6.5 -6.5,6.5 H 10.1 c -3.6,0 -6.5,-3 -6.5,-6.5 V 10 c 0,-3.6 3,-6.5 6.5,-6.5 h 127.4 c 3.6,0 6.5,3 6.5,6.5 z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    id: "g116"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "m 90.7,121 c 3.2,-1.3 4.8,-3.5 4.8,-7.1 0,-0.2 0,-0.4 0,-0.6 -0.3,-4.8 -4.1,-7.1 -8.6,-7.1 H 74.8 v 24.2 h 5.8 v -8.7 h 4.1 l 4.5,8.7 h 6.5 z m -4.8,-3.4 h -5.7 v -7.1 h 5.7 c 2.2,0 3.5,1 3.5,3.5 0.2,2.4 -1.1,3.6 -3.5,3.6 z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "m 43.9,106.3 h -6.5 l -4.1,10.6 -4.5,-7.8 c -0.9,-1.4 -3,-2.7 -4.8,-2.7 h -3.3 l 10,17.5 -2.6,6.8 h 3.5 c 1.7,0 3.6,-1.3 4.2,-2.9 z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m 61.3,119.9 h -8.2 l 3.5,-9.1 c 0.4,-1 1,-1 1.3,0 z m 1.5,4.2 v 0 l 2.5,6.5 h 6.1 l -8.1,-21.3 c -0.6,-1.6 -2.6,-2.9 -4.2,-2.9 H 52 l -9.1,24.2 h 3 c 1.7,0 3.6,-1.3 4.2,-2.9 l 1.3,-3.5 h 11.4 z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m 110.9,110.9 c 0.4,-1 1,-1 1.3,0 l 3.5,9.1 h -8.2 z m -4.9,13.2 h 11.3 l 1.3,3.5 c 0.6,1.6 2.5,2.9 4.2,2.9 h 3 l -9.3,-24.2 h -7 c -1.7,0 -3.6,1.3 -4.2,2.9 l -8.1,21.3 h 6.1 z",
    className: "st0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    id: "g126"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 94.4,61.2 c 0.3,0.2 1,0.2 1.7,0.2 2.6,0 7.7,0 10.7,0 -5.4,-4.8 -8.7,-16.7 -8.7,-23.8 0,-7.3 3.3,-19.1 8.7,-23.8 -2.9,0 -8,0 -10.7,0 -0.6,0 -1.4,0 -1.7,0.2 0,0 -9.6,9.1 -9.6,23.6 0,14.5 9.6,23.6 9.6,23.6 z",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "m 71.3,61.2 c 0.3,0.2 1,0.2 1.7,0.2 2.6,0 7.7,0 10.6,0 -5.4,-4.8 -8.7,-16.7 -8.7,-23.8 0,-7.3 3.5,-19.1 8.7,-23.8 -2.9,0 -8,0 -10.6,0 -0.6,0 -1.4,0 -1.7,0.2 0,0 -9.6,9.3 -9.6,23.6 0.2,14.3 9.6,23.6 9.6,23.6 z",
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 48.4,61.2 c 0.3,0.2 1,0.2 1.6,0.2 2.7,0 7.8,0 10.7,0 C 55.3,56.6 52,44.7 52,37.6 c 0,-7.3 3.3,-19.1 8.7,-23.8 -2.9,0 -8,0 -10.7,0 -0.6,0 -1.4,0 -1.6,0.2 0,0 -9.6,9.1 -9.6,23.6 0,14.5 9.6,23.6 9.6,23.6 z",
    className: "st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "m 123.6,80.2 c -1.6,-3.3 -4.5,-9 -4.9,-10.9 0,0 -1.7,-4.3 2.9,-5.1 1.9,-0.3 3.2,-1.7 3.3,-3.5 v -2.2 c 0,-0.3 -0.3,-0.6 -0.6,-0.6 h -7.5 c -0.2,0 -5.4,0.6 -5.4,7 -0.2,10.9 0,12.2 -2.9,12.8 -0.3,0 -0.4,-0.3 -0.4,-0.4 v 0 c 0,-0.2 0,-0.2 0,-0.3 0,-5.8 -4.6,-10.5 -10.5,-10.5 -2.9,0 -5.7,1.3 -7.4,3.2 v 0 c 0,0.2 -0.3,0.3 -0.4,0.3 -0.2,0 -0.4,-0.2 -0.4,-0.3 -1.9,-1.9 -4.5,-3.2 -7.4,-3.2 -2.9,0 -5.7,1.3 -7.4,3.2 v 0 c 0,0.2 -0.3,0.3 -0.4,0.3 -0.2,0 -0.4,-0.2 -0.4,-0.3 v 0 c -1.9,-1.9 -4.5,-3.2 -7.4,-3.2 -2.9,0 -5.7,1.3 -7.4,3.2 v 0 c 0,0.2 -0.3,0.3 -0.4,0.3 -0.2,0 -0.4,-0.2 -0.4,-0.3 v 0 c -1.9,-1.9 -4.5,-3.2 -7.4,-3.2 -5.8,0 -10.5,4.6 -10.5,10.5 0,0.2 0,0.2 0,0.3 v 0 c 0,0.3 -0.3,0.4 -0.6,0.4 -2.9,-0.4 -2.7,-1.9 -2.9,-12.8 0,-6.4 -5.2,-7 -5.4,-7 h -7.8 c -0.3,0 -0.6,0.3 -0.6,0.6 v 2.2 c 0.2,1.9 1.3,3.3 3.3,3.5 4.6,0.7 2.9,5.1 2.9,5.1 -0.4,1.9 -3.3,7.5 -4.9,10.9 -1,2.2 -3.2,7.4 0.2,12.6 1.9,3 4.2,5.7 12.3,5.7 h 75 c 8.1,0.2 10.5,-2.6 12.3,-5.7 v 0 c 2.6,-5.1 0.6,-10.5 -0.5,-12.6 z M 50,83.1 c -3.5,0 -6.2,-2.7 -6.2,-6.2 0,-3.5 2.7,-6.2 6.2,-6.2 3.5,0 6.2,2.7 6.2,6.2 0.1,3.4 -2.9,6.2 -6.2,6.2 z m 15.8,0 c -3.5,0 -6.2,-2.7 -6.2,-6.2 0,-3.5 2.7,-6.2 6.2,-6.2 3.5,0 6.2,2.7 6.2,6.2 0,3.4 -2.7,6.2 -6.2,6.2 z m 15.8,0 c -3.5,0 -6.2,-2.7 -6.2,-6.2 0,-3.5 2.7,-6.2 6.2,-6.2 3.5,0 6.2,2.7 6.2,6.2 0,3.4 -2.7,6.2 -6.2,6.2 z m 15.9,0 c -3.5,0 -6.2,-2.7 -6.2,-6.2 0,-3.5 2.7,-6.2 6.2,-6.2 3.5,0 6.2,2.7 6.2,6.2 0.1,3.4 -2.7,6.2 -6.2,6.2 z",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaraSmallLogo);
export default __webpack_public_path__ + "static/media/yara-small-logo.fe8951b79a9ce41cb1e312addc7988eb.svg";
export { ForwardRef as ReactComponent };